module.exports = __webpack_public_path__ + "static/media/sail.97f14b7a.png";